import React, { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext();

export function useCart() {
  return useContext(CartContext);
}

export const PRODUCTS = {
  "hara-namak": { id: "hara-namak", name: "Hara Namak", price: 250, icon: null, description: "Pisi loon with green chilies and mountain herbs. No preservatives, no artificial colour.", weight: 200, bundleEligible: true },
  turmeric:     { id: "turmeric", name: "Turmeric Powder", price: 230, icon: null, description: "From high-altitude Uttarakhand farms.", weight: 150, bundleEligible: true },
  honey:        { id: "honey", name: "Mountain Honey", price: 490, icon: null, description: "Raw, unfiltered honey from wild beehives above 6,000 ft.", weight: 250, bundleEligible: false },
  "hemp-salt":  { id: "hemp-salt", name: "Hemp Seed Salt", price: 249, icon: null, description: "Cold-pressed hemp seeds blended with Himalayan mineral salt.", weight: 150, bundleEligible: true },
  "flax-salt":  { id: "flax-salt", name: "Flax Seed Salt", price: 249, icon: null, description: "Roasted flax seeds with mineral-rich mountain salt.", weight: 150, bundleEligible: true },
  "test-1":     { id: "test-1", name: "TEST Do Not Buy", price: 2, icon: null, description: "Test product for internal checks only.", weight: 1, bundleEligible: false },
};

var BUNDLE_MIN_QTY = 2;
var BUNDLE_DISCOUNT_PCT = 10;

export function CartProvider({ children }) {
  const [cart, setCart] = useState([]);

  useEffect(() => {
    const saved = localStorage.getItem("purejar_cart");
    if (saved) setCart(JSON.parse(saved));
  }, []);

  useEffect(() => {
    localStorage.setItem("purejar_cart", JSON.stringify(cart));
  }, [cart]);

  const addToCart = (productId) => {
    const product = PRODUCTS[productId];
    if (!product) return;
    setCart((prev) => {
      const existing = prev.find((i) => i.id === productId);
      if (existing) return prev.map((i) => i.id === productId ? { ...i, quantity: i.quantity + 1 } : i);
      return [...prev, { id: productId, name: product.name, price: product.price, quantity: 1, weight: product.weight }];
    });
  };

  const removeFromCart = (productId) => {
    setCart((prev) => prev.filter((i) => i.id !== productId));
  };

  const updateQuantity = (productId, quantity) => {
    if (quantity < 1) { removeFromCart(productId); return; }
    setCart((prev) => prev.map((i) => i.id === productId ? { ...i, quantity } : i));
  };

  const clearCart = () => setCart([]);

  function isBundleEligible(item) {
    var product = PRODUCTS[item.id];
    return product && product.bundleEligible;
  }

  const eligibleQty = cart.reduce((sum, i) => isBundleEligible(i) ? sum + i.quantity : sum, 0);
  const bundleActive = eligibleQty >= BUNDLE_MIN_QTY;

  const eligibleSubtotal = cart.reduce((sum, i) => isBundleEligible(i) ? sum + (i.price * i.quantity) : sum, 0);
  const bundleDiscount = bundleActive ? Math.round(eligibleSubtotal * (BUNDLE_DISCOUNT_PCT / 100)) : 0;

  const subtotal = cart.reduce((sum, i) => sum + i.price * i.quantity, 0);
  const total = subtotal - bundleDiscount;

  return (
    <CartContext.Provider value={{
      cart, addToCart, removeFromCart, updateQuantity, clearCart,
      subtotal, total, bundleDiscount, bundleActive, eligibleQty,
      BUNDLE_MIN_QTY, BUNDLE_DISCOUNT_PCT, PRODUCTS
    }}>
      {children}
    </CartContext.Provider>
  );
}